<smt-modal 
    [(isActive)]="enableShiftBlockModal" 
    (acceptEvent)="saveQuickEdit()"
    (rejectEvent)="enableShiftBlockModal = false" 
    acceptText="Save" 
    acceptCssClass="button primary" 
    rejectText="Cancel"
    rejectCssClass="button cancel">

    <div role="header">
        {{ detailShiftBlockDescription ? detailShiftBlockDescription : "" }}
    </div>
    <div role="body">
        <div class="form-group compact">
            <label>Variable Job Titles</label>
            <select name="detailJobTitle" id="detailJobTitleDropDown" class="body-dropdown"
                [(ngModel)]="detailJobTitle">
                <option>{{ DetailDefault }}</option>
                <option *ngFor="let jobTitle of jobTitles" [ngValue]="jobTitle.id">
                    {{ jobTitle.abbreviation }}
                </option>
            </select>
        </div>
        <div class="form-group compact">
            <label>Census Range From (Low Number)</label>
            <select name="censusCountDetailFrom" id="censusCountDetailFromDropDown" class="body-dropdown"
                [(ngModel)]="detailCensusCountFrom">
                <option>{{ DetailDefault }}</option>
                <option *ngFor="let censusCount of selectedCensusCounts" [ngValue]="censusCount">
                    {{ censusCount }}
                </option>
            </select>
        </div>
        <div class="form-group compact">
          <label>Census Range To (High Number)</label>
          <select name="censusCountDetailTo" id="censusCountDetailToDropDown" class="body-dropdown"
                [(ngModel)]="detailCensusCountTo">
                <option>{{ DetailDefault }}</option>
                <option *ngFor="let censusCount of selectedCensusCounts" [ngValue]="censusCount">
                    {{ censusCount }}
                </option>
            </select>
        </div>
        <div class="form-group compact">
            <label>Type</label>
            <ul class="options">
                <li>
                    <label>
                        <input type="radio" selected name="modalRatioYes" (change)="detailTypeChange()" [value]="true"
                            [(ngModel)]="detailUseRatio">Ratio
                    </label>
                </li>
                <li>
                    <label>
                        <input type="radio" name="modalRatioNo" (change)="detailTypeChange()" [value]="false"
                            [(ngModel)]="detailUseRatio">Total
                    </label>
                </li>
            </ul>
        </div>
        <div class="form-group compact">
            <label>{{ detailUseRatioLabel }}</label>
            <input type="number" name="ratioDetail" [(ngModel)]="detailValue">
        </div>
    </div>
</smt-modal>
<div>
    <div class="table-wrap">
        <div *ngIf="jobTitles && jobTitles.length > 0" class="quick-edit">
            <select *ngIf="!readOnly" class="compact" [formControl]="quickEditSelect">
                <option value="-1">All</option>
                <option *ngFor="let shiftBlock of shiftBlocks" [value]="shiftBlock.startHour">
                    {{ shiftBlock.description }}</option>
            </select>
            <button *ngIf="!readOnly" type="button" class="primary compact" (click)="editShiftBlock()">Quick Edit</button>
            <button *ngIf="!readOnly && copySource" type="button" class="primary compact right" (click)="onCopy()">{{ shiftSchedule && shiftSchedule.isWeekend ? 'Copy Weekday to Weekend' : 'Copy Weekend to Weekday' }}</button>
            <button type="button" class="primary compact right" (click)="onViewFullStaffingGrid()">View Full Staffing Grid</button>
        </div>      
        <table
            class="variable"
            [class.title1]="jobTitles.length === 1"
            id="variableStaffingList" class="condensed form-group">
            <thead class="fixed-header">
                <tr class="shift-block-head">
                    <ng-container *ngFor="let shiftBlock of shiftBlocks">
                        <th class="census"></th>
                        <th [colSpan]="jobTitles.length">{{ shiftBlock.description }}</th>
                    </ng-container>
                </tr>
                <tr>
                    <ng-container *ngFor="let shiftBlock of shiftBlocks">
                        <th class="census"></th>
                        <th *ngFor="let jobTitle of jobTitles">
                            {{ jobTitle.abbreviation }}
                        </th>
                    </ng-container>
                </tr>
            </thead>
            <tbody class="scrolling-body">
                <tr *ngFor="let row of staffingGrid; let i = index;">                    
                    <ng-container *ngFor="let cell of row; let cellIndex = index;">
                        <td class="census" *ngIf="cellIndex % jobTitles.length === 0">
                            {{ maxCensus - i }}
                        </td>
                        <td>
                            <smt-staffing-grid-value [(gridCell)]="row[cellIndex]" (keyPressed)="cellKeyPressed($event)" [required]="!costCenter.inactiveDate" [readOnly]="readOnly"></smt-staffing-grid-value>
                        </td>
                    </ng-container>
                </tr>
            </tbody>
        </table>
    </div> 
</div>
